var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "right-menu", staticStyle: { display: "flex" } },
      [
        _c(
          "span",
          {
            staticClass: "days",
            style: {
              color: _vm.list[_vm.state].color,
              background: _vm.list[_vm.state].bgColor,
              borderColor: _vm.list[_vm.state].color
            }
          },
          [
            _vm._v(
              "客莱宝有效期剩余 " +
                _vm._s(
                  _vm.days != null || _vm.days != undefined ? _vm.days : 0
                ) +
                "天"
            )
          ]
        ),
        _c(
          "el-dropdown",
          {
            staticClass: "avatar-container right-menu-item",
            attrs: { placement: "bottom", trigger: "click" }
          },
          [
            _c("span", { staticClass: "avatar-name" }, [
              _vm._v(_vm._s(_vm.getAvatarName(_vm.user.name)))
            ]),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c("el-dropdown-item", [
                  _c(
                    "div",
                    {
                      staticStyle: { "font-size": "12px", padding: "0 20px" },
                      on: {
                        click: function($event) {
                          return _vm.exit()
                        }
                      }
                    },
                    [_vm._v(" 退出 ")]
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        [
          _c("div", { staticClass: "right-txt" }, [
            _c("span", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(_vm._s(_vm.user.name))
            ])
          ])
        ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }